<template>
	<div
		v-if="navItems.length > 2"
		class="footer-nav-mobile"
	>
		<div
			v-for="item in navItems"
			:key="item.label"
			class="footer-nav-mobile__item"
			:class="{ 'is-active': item.active }"
		>
			<a
				:href="item.href"
				class="footer-nav-mobile__item-link"
			>
				<Icon
					:icon-name="item.icon"
					size="lg"
				/>
				<span class="footer-nav-mobile__item-label">
					{{ item.label }}
				</span>
			</a>
		</div>
	</div>
</template>

<script>
import Icon from '@shared/components/Icon';
import laroute from '@laroute';

export default {
	name:       'FooterNavMobile',
	components: {
		Icon,
	},
	computed: {
		navItems() {
			const items = [];
			items.push({
				label:  this.$I18n.trans('commons.arena_profile'),
				icon:   'stadium',
				href:   '/',
				active: window.location.pathname === '/',
			});

			if (this.$arenaConfig.followingEnabled) {
				items.push({
					label:  this.$I18n.trans('arena.feed.label'),
					icon:   'feed',
					href:   `${laroute.route('arena.feed')}`,
					active: window.location.pathname.startsWith('/feed'),
				});
			}

			if (this.$arenaConfig.enableMomentsFeed) {
				items.push({
					label:  this.$I18n.trans('event.multiformat_editor.title'),
					icon:   'formatconverter',
					href:   `${laroute.route('arena.moments')}`,
					active: window.location.pathname.startsWith('/moments'),
				});
			}

			items.push({
				label:  this.$I18n.trans('commons.profile'),
				icon:   'account',
				href:   laroute.route('arena.fan_account'),
				active: window.location.pathname.startsWith('/account'),
			});
			return items;
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';

.footer-nav-mobile {
	@include z-index(arena-sticky-mobile-footer-nav);
	position: sticky;
	bottom: 0;
	display: flex;
	justify-content: space-evenly;
	align-items: center;
	background-color: var(--color-grey-950);
}

// .footer-nav-mobile__item {}

.footer-nav-mobile__item-link {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: $sp2;
	padding: $sp3;

	.footer-nav-mobile__item.is-active & {
		color: var(--color-hype-yellow);
	}
}

.footer-nav-mobile__item-label {
	font-size: 10px; // stylelint-disable-line
}
</style>
